module.exports = __webpack_public_path__ + "static/media/logos_rappi-mustache.3c571bba.svg";